import { useEffect, useState } from "react";
import IconDon from "@/assets/icons/don.svg?react";
import AdsIcon from "@/assets/icons/ad-circle-on.svg?react";
import BonusIcon from "@/assets/icons/coins.svg?react";
import UnlimitedIcon from "@/assets/icons/rocket.svg?react";
import DiamondFilled from "@/assets/icons/diamond-filled-linear.svg?react";
import { useTranslation } from "react-i18next";
import BuyPremiumBanner from "./components/BuyPremiumBanner.tsx";
import BaseButton from "../../../components/base/button/BaseButton.tsx";
import PageWrapper from "../../../components/PageWrapper.tsx";
import {
  useGetPremium,
  usePremiumInfos,
  useProviders,
} from "@/pages/profile/api";
import { formatNumber } from "@/shared/utils";
import dayjs from "dayjs";
import { openLink } from "@telegram-apps/sdk-react";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";

export default function BuyPremiumPage() {
  const { t } = useTranslation();

  const { data: premium, isLoading } = usePremiumInfos();

  const [selectedId, setSelectedId] = useState(premium?.[0].id);
  useEffect(() => {
    setSelectedId(premium?.[0].id);
  }, [premium]);
  const activePremium = premium?.find((item) => item.id === selectedId);

  const { data: providers, isLoading: isLoadingProviders } = useProviders();
  const [selectedMerchant, setSelectedMerchant] = useState(
    providers?.[0].merchant
  );
  useEffect(() => {
    setSelectedMerchant(providers?.[0].merchant);
  }, [providers]);

  function getEndDateAndDays(months: number) {
    const today = new Date();
    const startMonth = today.getMonth();
    let totalDays = 0;
    for (let i = 0; i < months; i++) {
      const tempDate = new Date(today.getFullYear(), startMonth + i + 1, 0);
      totalDays += tempDate.getDate();
    }

    today.setMonth(today.getMonth() + months);
    return {
      endDate: dayjs(today).format("DD.MM.YYYY"),
      totalDays,
    };
  }

  const { mutate: getPremiumMutation } = useGetPremium();
  function getPremium() {
    if (!selectedMerchant || !selectedId) return;

    getPremiumMutation(
      {
        merchant: selectedMerchant,
        return_url: import.meta.env.VITE_APP_TG_URL,
        premium_option_id: selectedId,
      },
      {
        onSuccess: (res) => {
          openLink(res.url, {
            tryInstantView: false,
            tryBrowser: "google-chrome",
          });
        },
      }
    );
  }

  return (
    <PageWrapper backPath="/profile">
      <div className="gap-6 px-4 flex flex-col justify-between pt-4">
        <div className="grid gap-5">
          <BuyPremiumBanner />

          <div className="bg-white/08 grid rounded-xl overflow-hidden pl-3 border-b border-b-white/08">
            {/* {tasks.map((task) => {
              const Icon = task.Icon;
              return (
                <div
                  key={task.id}
                  className="flex items-center justify-start gap-2 py-2 relative group"
                >
                  <Icon
                    width="24"
                    height="24"
                    className="text-gray-1 shrink-0"
                  />
                  <p className="w-full pr-3 text-xs font-semibold text-white leading-130">
                    {task.title}
                  </p>
                  <hr className="border-none bg-white/08 h-px w-full absolute left-8 bottom-0 group-last:hidden" />
                </div>
              );
            })} */}
            <TaskList
              donValue={
                premium?.find((item) => item.id === selectedId)?.don_award ?? 0
              }
            />
          </div>

          <div>
            <h2 className="text-white leading-130 mb-3 font-bold text-lg">
              {t("tariffs")}
            </h2>
            <div className="gap-3 grid">
              {isLoading
                ? Array.from({ length: 3 }).map((_, idx) => (
                    <div
                      key={idx}
                      className="p-4 bg-gray-4 rounded-[11px] flex-center-between border-white/08 border-b"
                    >
                      <div className="flex items-center gap-x-2.5">
                        <div className="w-9 h-9 skeleton bg-white/08 rounded-full" />
                        <div>
                          <div className="rounded-full skeleton w-14 h-3 mb-1"></div>
                          <div className="rounded-full skeleton w-20 h-4"></div>
                        </div>
                      </div>
                      <div className="flex-center gap-3">
                        <div className="h-5 w-24 skeleton rounded-full" />
                        <div className="w-6 h-6 rounded-full skeleton" />
                      </div>
                    </div>
                  ))
                : premium?.map((item) => {
                    return (
                      <VibratingButton
                        vibrationType="selection"
                        key={item.id}
                        className={`p-px rounded-xl cursor-pointer transition-300 ${
                          selectedId === item.id
                            ? "bg-yellow-linear shadow-[0_7px_33px_-24px_rgba(235,_161,_50,_0.24)]"
                            : "bg-transparent"
                        }`}
                        onClick={() => setSelectedId(item.id)}
                      >
                        <div
                          className={`p-4 bg-gray-4 rounded-[11px] flex-center-between transition-300 border-b ${
                            selectedId === item.id
                              ? "bg-[linear-gradient(83deg,_rgba(251,199,108,0.08)_-31.43%,_rgba(235,161,50,0.08)_100%)] border-transparent"
                              : "border-white/08"
                          }`}
                        >
                          <div className="flex items-center gap-x-2.5">
                            <div className="p-1.5 w-9 bg-white/08 rounded-full flex-center">
                              <DiamondFilled width="24" height="24" />
                            </div>
                            <div>
                              <p className="text-xs font-normal leading-130 text-gray-1 uppercase mb-0.5">
                                premium
                              </p>
                              <p className="text-white leading-130 font-semibold text-base lowercase">
                                {item.months === 12 ? 1 : item.months}{" "}
                                {item.months === 12
                                  ? t("yearly")
                                  : t("monthly")}
                              </p>
                            </div>
                          </div>
                          <div className="flex-center gap-3">
                            <div>
                              <div className="gap-1.5 flex items-center mb-0.5 justify-end">
                                {item.don_award && (
                                  <span className="text-xs text-gray-1 font-normal leading-130 text-right">
                                    {formatNumber(item.don_award)} {"DON"}
                                  </span>
                                )}
                                {item.percentage ? (
                                  <span className="px-0.5 rounded-full text-xs font-semibold leading-130 bg-yellow-linear text-dark text-center">
                                    +{item.percentage}%
                                  </span>
                                ) : null}
                              </div>
                              <p className="leading-130 text-right text-white font-bold text-base">
                                {formatNumber(item.price)} UZS
                              </p>
                            </div>
                            <div>
                              <input
                                className="w-0 h-0 peer hidden"
                                type="radio"
                                checked={selectedId === item.id}
                                readOnly
                              />
                              <div className="w-6 h-6 rounded-full border border-white/08 peer-checked:bg-blue peer-checked:border-blue transition-200 relative after:absolute after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:w-3 after:h-3 after:rounded-full after:bg-white after:duration-200 after:opacity-0 peer-checked:after:opacity-100 peer-checked:after:drop-shadow-[0_0_10px_#00224B]" />
                            </div>
                          </div>
                        </div>
                      </VibratingButton>
                    );
                  })}
            </div>
          </div>

          {activePremium && (
            <div className="bg-white/08 rounded-xl px-3 border-b border-white/08">
              <div className="flex items-center py-3 px-0 justify-between border-b border-b-white/08">
                <p className="text-gray-1 leading-130 text-xs font-normal">
                  {t("expire_date")}
                </p>
                <p className="leading-130 text-right font-medium text-xs text-white">
                  {dayjs(new Date()).format("DD.MM.YYYY")} -{" "}
                  {getEndDateAndDays(activePremium?.months).endDate}
                </p>
              </div>
              <div className="flex py-3 px-0 items-center justify-between border-b-white/08">
                <p className="text-gray-1 leading-130 text-xs font-normal">
                  {t("expiration_date")}
                </p>
                <p className="leading-130 text-right font-medium text-xs text-white">
                  {getEndDateAndDays(activePremium?.months).totalDays}{" "}
                  {t("day")}
                </p>
              </div>
              {/* <div className="flex  py-3 px-0 items-center justify-between">
                <p className="text-white leading-130 text-xs font-normal">
                  {t("tariff_price")}
                </p>
                <p className="leading-130 text-right text-xl font-bold text-white">
                  {formatNumber(
                    activePremium?.discounted_price || activePremium?.price || 0
                  )}{" "}
                  UZS
                </p>
              </div> */}
            </div>
          )}

          <div>
            <h2 className="text-white leading-130 mb-3 font-bold text-lg">
              {t("choose_payment_method")}
            </h2>
            <div className="gap-3 grid grid-cols-2">
              {isLoadingProviders
                ? Array.from({ length: 3 }).map((_, idx) => (
                    <div
                      key={idx}
                      className="p-3 flex-center-between gap-3 rounded-xl cursor-pointer transition-300 border flex-center-between border-transparent bg-[#212127]"
                    >
                      <div className="h-5 w-16 rounded-lg skeleton" />
                      <div className="w-6 h-6 rounded-full skeleton" />
                    </div>
                  ))
                : providers?.map((item) => {
                    return (
                      <VibratingButton
                        vibrationType="selection"
                        key={item.id}
                        className={`p-3 rounded-xl cursor-pointer transition-300 border flex-center-between ${
                          selectedMerchant === item.merchant
                            ? "border-blue bg-blue/[0.12] shadow-[0_7px_33px_-24px_rgba(37,133,255,0.24)]"
                            : "border-transparent bg-[#212127]"
                        }`}
                        onClick={() => setSelectedMerchant(item.merchant)}
                      >
                        <img
                          className="max-h-5 max-w-4/5 object-contain"
                          src={item.logo.url}
                          alt={item.title}
                        />
                        <div className="flex-center gap-3">
                          <div>
                            <input
                              className="w-0 h-0 peer hidden"
                              type="radio"
                              checked={selectedMerchant === item.merchant}
                              readOnly
                            />
                            <div className="w-6 h-6 rounded-full border border-white/08 peer-checked:bg-blue peer-checked:border-blue transition-200 relative after:absolute after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:w-3 after:h-3 after:rounded-full after:bg-white after:duration-200 after:opacity-0 peer-checked:after:opacity-100 peer-checked:after:drop-shadow-[0_0_10px_#00224B]" />
                          </div>
                        </div>
                      </VibratingButton>
                    );
                  })}
            </div>
          </div>
        </div>

        <div className="pb-safe-bottom bottom-0 left-0 sticky bg-dark w-full">
          <BaseButton
            vibrate={true}
            vibrationType="soft"
            className="w-full"
            text={t("pay")}
            onClick={getPremium}
            disabled={!selectedMerchant || !selectedId}
          />
        </div>
      </div>
    </PageWrapper>
  );
}

interface TaskItemProps {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  isLast?: boolean;
}

const TaskItem = ({ Icon, title, isLast }: TaskItemProps) => {
  return (
    <div className="flex items-center justify-start gap-2 py-2 relative group">
      <Icon width="24" height="24" className="text-gray-1 shrink-0" />
      <p className="w-full pr-3 text-xs font-semibold text-white leading-130">
        {title}
      </p>
      {!isLast && (
        <hr className="border-none bg-white/08 h-px w-full absolute left-8 bottom-0" />
      )}
    </div>
  );
};

interface TaskListProps {
  donValue: number | string;
}

export const TaskList = ({ donValue }: TaskListProps) => {
  const { t } = useTranslation();
  return (
    <div className="task-list">
      <TaskItem Icon={IconDon} title={t("double_don")} isLast={false} />
      <TaskItem
        Icon={BonusIcon}
        title={`${t("bonus_don", {
          value: formatNumber(donValue),
        })}`}
        isLast={false}
      />
      <TaskItem
        Icon={AdsIcon}
        title={t("see_more_ads_and_get_more_don")}
        isLast={false}
      />
      <TaskItem
        Icon={UnlimitedIcon}
        title={t("unlimited_challenges")}
        isLast={true}
      />
    </div>
  );
};
